import { type ExpressionType } from '../../IExpression.ts';
import { type IAssignableExpression } from '../assignable/IAssignableExpression.ts';

export interface IComputedDateExpression {
  type: ExpressionType.ComputedDate;
  /** Data di riferimento */
  from: IAssignableExpression;
  offsets: IComputedDateExpressionOffset[];
}

export enum ComputedDateOffsetUnit {
  Days = 'days',
  Months = 'months',
  Years = 'years',
}

export interface IComputedDateExpressionOffset {
  unit: ComputedDateOffsetUnit;
  amount: IAssignableExpression;
}
